import { BzAlertActions } from './alert.actions';

export const initialAppAlertState: IBzAlertState = {alertMessages: []};

export function bzAlertReducer (state: IBzAlertState = initialAppAlertState, action: any) {
  const object: any = Object;
  switch (action.type) {
    case BzAlertActions.ADD:
      return object.assign({}, state, {alertMessages: action.payload});
    default:
      return state;
  }
};
